import PrimaryUrlService from '../services/primaryUrlService'

export const passwordMixin = {
    data() {
        return {
            loading: false,
            error: false,
            passwordMode: true,
            form: {
                login: '',
                password: '',
                remember: false,
            },
            rules: {
                login: [
                    value => !!value || 'Required.',
                ],
                password: [
                    value => !!value || 'Required.',
                ],
            },
        };
    },
    mounted() {
        if (this.$root.login) {
            this.loggedIn();
        }
    },
    methods: {
        login() {
            this.loading = true;
            this.$sessionService.authenticate(this.form.login, this.form.password, this.form.remember)
                .then(response => {
                    this.loading = false;
                    if (response.data.login) {
                        this.loggedIn();
                    } else {
                        this.error = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.error = true;
                    }
                    this.loading = false;
                });
        },
        loggedIn() {
            this.checkInvite().
                then(
                    () => {
                        let invite = this.$inviteService.get()
                        this.$inviteService.remove()
                        this.$router.replace({ name: "invite", params: {invite: invite} })
                    }
                ).catch(() => {
                    const primaryUrlService = new PrimaryUrlService();
                    this.$ticketService.ticketValid()
                        .then(
                            () => this.$router.replace({ name: 'ticketSelect' })
                        )
                        .catch(
                            () => window.location.href = primaryUrlService.restoreUrl()
                        )
                });
        },
        async checkInvite() {
            await this.$inviteService.inviteValid()
                .then(() => Promise.resolve())
                .catch(() => Promise.reject());
        },
        back() {
            this.$emit('back');
        }
    },

    computed: {
        canLogin() {
            return !!this.form.login
                && !!this.form.password;
        }
    }
};
